import { useContext, useEffect, useState } from "react";
import { AuthContext, AuthStatus } from "@/contexts/AuthContext";

// AuthContext のauthStatus にlocalStorage の状態を加味した認証状態を提供する。
// context にしてしまうとページ遷移などでmount されないためcustom hook として必要な各画面で利用する。
const useFixedAuth = () => {
  const {
    authStatus,
    userInfo,
    sessionInfo,
    newPasswordRequired,
    fixSignedOutState,
  } = useContext(AuthContext);
  const [fixedAuthStatus, setFixedAuthStatus] = useState<AuthStatus>(
    AuthStatus.Loading
  );

  useEffect(() => {
    const fixed = fixSignedOutState();

    if (authStatus === AuthStatus.SignedIn && !fixed) {
      setFixedAuthStatus(AuthStatus.SignedIn);
    } else {
      setFixedAuthStatus(AuthStatus.SignedOut);
    }
  }, [authStatus, fixSignedOutState]);

  return {
    authStatus: fixedAuthStatus,
    userInfo,
    sessionInfo,
    newPasswordRequired,
  };
};

export default useFixedAuth;
